import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=dcbe6bde&scoped=true&"
import script from "./Environment.vue?vue&type=script&lang=js&"
export * from "./Environment.vue?vue&type=script&lang=js&"
import style0 from "./Environment.vue?vue&type=style&index=0&id=dcbe6bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe6bde",
  null
  
)

export default component.exports